"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StrategicPlanning() {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: descRef,
    isVisible: descVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section id="strategicplanning" className="bg-background py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <h2 ref={headingRef} className={`text-[36px] leading-[1.3] font-semibold tracking-[-0.2px] text-foreground mb-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            Strategic Planning
          </h2>

          <p ref={descRef} className={`text-[16px] leading-[1.6] font-normal text-muted-foreground transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-100 ${descVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            Our strategic planning services help you navigate complex business
            decisions with confidence. We provide comprehensive analysis,
            financial forecasting, and actionable insights to drive your
            business forward and achieve your long-term goals.
          </p>
        </div>
      </div>
    </section>;
}